import z from 'zod';
import { enumLabels } from '../common/fields';
import { ThemeModeSchema, UserTypeSchema } from '../common/schemas';
import { ACCOUNT_STATUS_LABELS, AccountStatus, MFA_METHOD_LABELS, MfaMethod } from './enums';

/**
 * Shared & Helper Schemas
 */

export const MfaMethodSchema = z
  .enum(MfaMethod)
  .register(enumLabels, { labels: MFA_METHOD_LABELS });

export const AccountStatusSchema = z
  .enum(AccountStatus)
  .register(enumLabels, { labels: ACCOUNT_STATUS_LABELS });

/** A user's account as Cognito holds it: whether, and how, they sign in. */
export const UserStatusSchema = z.object({
  enabled: z.boolean().meta({ title: 'Enabled' }),
  creationDatetime: z.number().meta({ title: 'Created at' }),
  accountStatus: AccountStatusSchema.meta({ title: 'Account status' }),
  mfaMethod: MfaMethodSchema.meta({ title: 'MFA Method' }),
  temporaryPassword: z.string().optional().meta({ title: 'Temporary password' }),
});

export const UserIdSchema = z
  .string()
  // Based on AWS Cognito's username format, which notably looks like a UUID,
  // but doesn't follow UUID convention
  .regex(/^[\p{L}\p{M}\p{S}\p{N}\p{P}]{1,128}$/u)
  .openapi({
    description: 'Unique username for the user',
    example: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
  });

export const DBUserSharedSettingsSchema = z.object({
  themeMode: ThemeModeSchema,
});

export const DBUserTypeSchema = UserTypeSchema;
